import { render } from "./HomeButton.vue?vue&type=template&id=ec578b08&scoped=true"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"

import "./HomeButton.vue?vue&type=style&index=0&id=ec578b08&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-ec578b08"

export default script